import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles.css";
import ProtectedRoute from "../component/common/ProtectedRoute";
import Unauthorized from "../screens/AuthScreen/Unauthorised";

import Venue from "../screens/VenueScreen/VenueListPage";
import VenueDetails from "../screens/VenueScreen/VenueDetailsPage";
import PitchFrames from "../screens/VenueScreen/PitchBooking";
import Accessories from "../screens/CartViewScreen/Accessories";
import Viewcart from "../screens/CartViewScreen/ViewCartPage";
import PaymentSuccessful from "../screens/PaymentScreen/SuccessfullPage";
import ItemDetailsPage from "../screens/CartViewScreen/ItemDetailsPage";
import AutoLogin from "../screens/AuthScreen/AutoLogin";

// Define routes
const Routing = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/auto-login" element={<AutoLogin />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Commented routes - kept as is */}
          {/* <Route path="/sign" element={<Sign />} /> */}
          {/* <Route path="/sign-up" element={<SignupPage />} /> */}
          {/* <Route path="/sign-in/forgot-password" element={<ForgotPassword />} /> */}
          {/* <Route path="/sign-in" element={<SignIn />} /> */}
          {/* <Route
            path="/verification/email/:email/token/:token/fullname/:fullname"
            element={<VerificationPage />}
          /> */}
          {/* <Route
            path="/my-account"
            element={
              <MyAccountPage isOpen={isOpen} toggleSidebar={toggleSidebar} />
            }
          /> */}

          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Venue />
            </ProtectedRoute>
          } />
          <Route path="/venue-listing-page/venue/:name" element={
            <ProtectedRoute>
              <VenueDetails />
            </ProtectedRoute>
          } />
          <Route
            path="/venue-listing-page/venue/:venuenamefromurl/booking-page/:event"
            element={
              <ProtectedRoute>
                <PitchFrames />
              </ProtectedRoute>
            }
          />
          <Route
            path="/venue-listing-page/venue/:name/booking-page/accessories"
            element={
              <ProtectedRoute>
                <Accessories />
              </ProtectedRoute>
            }
          />
          <Route path="/viewcart" element={
            <ProtectedRoute>
              <Viewcart />
            </ProtectedRoute>
          } />
          <Route
            path="/payment-successfull/:platform/:id"
            element={
              <ProtectedRoute>
                <PaymentSuccessful />
              </ProtectedRoute>
            }
          />
          <Route
            path="/item-detail/:item_category/:name"
            element={
              <ProtectedRoute>
                <ItemDetailsPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
};

export default Routing;